/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShieldCheck, AlertCircle } from 'lucide-react';
import { useAlboStatus } from '@/components/albo/useAlboStatus';
import { AlboStatusBadge, AlboVerifiedInfo, AlboForm } from '@/components/albo/AlboParts';

const submitLabel = (state, saving, t) => {
  if (saving) return t('processing');
  return state.verified ? t('alboReverify') : t('alboVerifyNow');
};

export const AlboVerifyCard = () => {
  const { state, patch, saving, submit, t } = useAlboStatus();

  return (
    <Card data-testid="albo-verify-card">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between gap-3">
          <div>
            <CardTitle className="font-display flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-primary" /> {t('alboTitle')}</CardTitle>
            <CardDescription>{t('alboSubtitle')}</CardDescription>
          </div>
          <AlboStatusBadge verified={state.verified} number={state.number} t={t} />
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {state.verified && <AlboVerifiedInfo number={state.number} province={state.province} t={t} />}
        <AlboForm state={state} patch={patch} t={t} />
        {state.error && !state.verified && (
          <div className="text-xs text-destructive flex items-start gap-1.5"><AlertCircle className="h-3.5 w-3.5 mt-0.5" />{state.error}</div>
        )}
        <div className="flex justify-end">
          <Button onClick={submit} disabled={saving || !state.number || !state.province} data-testid="albo-submit-btn">
            {submitLabel(state, saving, t)}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default AlboVerifyCard;
